import React from 'react';
import { ProfileRadioCard } from '../atoms/ProfileRadioCard';
import { OreStack } from '@edenredespana/oreneta';
import { CreateProfileFormValues, MerchantType, ProfileType } from '../../domain/ProfileTypes';
import { UseFormRegister } from 'react-hook-form';
import { getProfileOptions } from '../../domain/ProfileConfig';
import { PROFILE_MODAL_STYLES } from '../styles/profileModalStyles';
import { useUserData } from '@/User/ui/context';

interface ProfileTypeSelectorProps {
  register: UseFormRegister<CreateProfileFormValues>;
  rolName: ProfileType;
  profileType: MerchantType;
}

export const ProfileTypeSelector: React.FC<ProfileTypeSelectorProps> = ({ 
  register, 
  rolName, 
  profileType 
}) => {
  const {merchant} = useUserData();
  const profileOptions = getProfileOptions(profileType, merchant.isNursery);

  return (
    <OreStack direction="row" style={PROFILE_MODAL_STYLES.selector.container}>
      {profileOptions.map((option) => (
        <ProfileRadioCard
          key={option.value}
          register={register}
          value={option.value}
          label={option.label}
          description={option.description}
          checked={rolName === option.value}
        />
      ))}
    </OreStack>
  );
};
